<template>
    <div class="layout justify-center wrap container text-xs-center" style="font-size: 20px;">
        {{$route.params.message}}
    </div>
</template>

<script>
    export default {
        name: 'Error',
        components: {

        },
        created() {
            if (Object.keys(this.$route.params).length === 0) {
                this.$router.push({name: 'root', replace: true})
            }
        },
    };
</script>